import styled from '@emotion/styled';

interface IButtonProps {
  disabled?: boolean;
  secondary?: boolean;
  blue?: boolean;
  black?: boolean;
  size?: 'small' | 'full';
  danger?: boolean;
  colorOverride?: string;
  lightText?: boolean;
  fontSize?: string;
  backgroundColor?: string;
}

export default styled.button <IButtonProps>`
  display: inline-block;
  height: 30px;
  color: ${props =>
    props.colorOverride
      ? props.colorOverride
      : props.danger || props.blue
        ? '#fff'
        : '#000'};

  background-color: ${props =>
    props.backgroundColor
      ? props.backgroundColor
      : props.secondary
        ? '#fff'
        : props.danger
          ? '#D32F2F'
          : props.blue
            ? '#029DFF'
            : props.black
              ? '#000'
              : '#D8D8D8'};
  opacity: ${props => (props.disabled ? '25%' : '100%')};
  padding: 0 14px;
  border-radius: 15px;
  border-width: 0px;
  font: 400 11px proxima-nova, sans-serif;
  border: ${props =>
    props.secondary ? '1px solid #979797' : '1px solid transparent'};
  border-color: ${props =>
    props.colorOverride ? props.colorOverride : 'none'};
  cursor: pointer;
  font-size: ${props => props.fontSize ? props.fontSize : '1rem'};
  font-weight: ${props => (props.lightText ? 'unset' : '700')};
  white-space: nowrap;
  min-width: ${props => (props.size === 'small' ? 'unset' : '96px')};
  margin-top: 4px;
  margin-bottom: 4px;
  line-height: 1;
  letter-spacing: 2px;
  margin-right: ${props => (props.size === 'full' ? 'unset' : '1.2rem')};
  width: ${props => (props.size === 'full' ? '100%' : 'unset')};
  :disabled {
    cursor: default;
  }
`;
